import Button from "./Button";
import React, { useState } from "react";
import ApiServices from "../api/services";
import { images } from "../assets/styles/Images";
import { useLoggedContext } from "../context/provider";
import { CardNumberElement, CardExpiryElement, CardCvcElement, useElements, useStripe } from "@stripe/react-stripe-js";

const CheckoutForm = ({ closeModal, getProfile, selected, teamSize, updatePlan, changeCard }) => {
  // Stripe
  const stripe = useStripe();
  const elements = useElements();

  const { subPlanId, setOpenSubscriptionPlansModal, updateUser, openSuccessModal, profileData } = useLoggedContext();

  // Use States
  const [error, setError] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleStripePayment = async () => {
    const cardNumberElement = elements.getElement(CardNumberElement);
    const result = await stripe.createToken(cardNumberElement);

    if (result.error) {
      throw new Error(result.error.message);
    } else {
      const payload = {
        card_last_four_digit: result.token.card.last4,
        card_token: result.token.id,
        card_type: result.token.card.brand,
        card_expiry_date: `${result.token.card.exp_month + "-" + result.token.card.exp_year}`,
      };

      await ApiServices.profile.addUserCard(payload);
      setToken(result.token.id); // Assuming you want to keep this for some reason.
      return result.token.id;
    }
  };

  // const subscribeToPlan = async (token) => {
  //   const formData = new FormData();
  //   formData.append("plan_id", subPlanId);
  //   // Add team size for Enterprise plans
  //   if (selected?.name?.toLowerCase() === "enterprise") {
  //     formData.append("max_user", teamSize);
  //   }

  //   console.log("plan_id", subPlanId);
  //   console.log("teamSize", teamSize);

  //   const res = await ApiServices.subscriptionPlans.subscribedPlan(formData);
  //   if (res.data.code === 200) {
  //     closeModal();
  //     updateUser(res?.data?.data);
  //     openSuccessModal({
  //       title: "Success!",
  //       message: "Congratulations! You are now part of the Edufeel family! Enjoy your subscription!",
  //       onPress: (close) => {
  //         close();
  //       },
  //     });
  //     setOpenSubscriptionPlansModal({ open: false });
  //   } else {
  //     throw new Error(res.data.message);
  //   }
  // };

  const subscribeToPlan = async (token) => {
    const formData = new FormData();
    formData.append("plan_id", selected?.id || subPlanId);

    // Add team size for Enterprise plans only if needed
    selected?.name?.toLowerCase() === "enterprise" && formData.append("max_user", teamSize);

    console.log("plan_id", selected?.id || subPlanId);
    console.log("teamSize", teamSize);

    // Use a cleaner ternary operation for the API call
    const res = await (updatePlan
      ? ApiServices.subscriptionPlans.profileSubscribedPlan(formData)
      : ApiServices.subscriptionPlans.subscribedPlan(formData));

    if (res.data.code === 200) {
      closeModal();
      updateUser(res?.data?.data);

      // Fix: Convert JSX-like syntax to proper JavaScript ternary
      updatePlan
        ? openSuccessModal({
            title: "Success!",
            message: "Your plan has been updated successfully!",
            onPress: (close) => {
              close();
              getProfile();
            },
          })
        : openSuccessModal({
            title: "Success!",
            message: "Congratulations! You are now part of the Edufeel family! Enjoy your subscription!",
            onPress: (close) => close(),
          });

      setOpenSubscriptionPlansModal({ open: false });
    } else {
      throw new Error(res.data.message);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (updatePlan) {
      subscribeToPlan();
    } else {
      if (!stripe || !elements) {
        setError("Stripe has not loaded yet. Please try again later.");
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const token = await handleStripePayment();

        if (subPlanId) {
          await subscribeToPlan(token);
        } else {
          closeModal();
          getProfile();
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className={`${changeCard ? "" : "mt-5 h-84 divide-y rounded border px-3 py-2"} `}>
        <div className="pt-1 pb-2">
          <h3 className="text-lg font-semibold text-secondary-color">Payment Method</h3>
        </div>

        {updatePlan ? (
          <div className="pt-4">
            <div className="">
              <img className="h-8 shrink-0" src={images.Stripe} alt="Stripe" />
            </div>
            <div className="flex items-center justify-between ">
              <div>
                <h2 className="text-xl font-semibold text-primary-color-100">
                  {profileData?.user?.card[0]?.card_type}*******{profileData?.user?.card[0]?.card_last_four_digit}
                </h2>
                {/* <h2 className="text-base font-semibold text-primary-color-100">Exp Date: {profileData?.user?.card[0]?.card_expiry_date}</h2> */}
              </div>
            </div>
          </div>
        ) : (
          <div className="mb-4 pt-4">
            <label className="mb-2 block text-base font-medium">
              Card number
              <CardNumberElement className="mt-2 h-11 w-full rounded-full border border-gray-300 px-4 pt-3 indent-5 text-base shadow-sm" />
            </label>
            <div className="mt-3 flex w-full items-center justify-between gap-x-3">
              <div className="w-6/12">
                <label className="mb-2 block text-base font-medium">
                  Expiry date
                  <CardExpiryElement className="mt-2 h-10 w-full rounded-full border border-gray-300 px-4 pt-3 indent-5 text-base shadow-sm" />
                </label>
              </div>
              <div className="w-6/12">
                <label className="mb-2 block text-base font-medium">
                  CVC
                  <CardCvcElement className="mt-2 h-10 w-full rounded-full border border-gray-300 px-4 pt-3 indent-5 text-base shadow-sm" />
                </label>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="mt-4">{error && <div className="text-sm text-red-500">{error}</div>}</div>
      <div className="mt-8 flex items-center justify-end gap-x-6">
        <button
          className="h-11 cursor-pointer rounded-full border border-secondary px-8 text-base font-medium text-secondary  3xl:h-12 3xl:text-lg"
          onClick={closeModal}
        >
          Cancel
        </button>
        <Button title={changeCard ? "Save card" : "Process"} loading={loading} onClick={handleSubmit} />
      </div>
    </form>
  );
};

export default CheckoutForm;
